import React, { lazy } from 'react'
import { howItWorksUrl } from '@/urls'
import { Navigate } from 'react-router-dom'
import { notFoundUrl,  buyBitcoinInfoUrl, brazilElectionsUrl } from '@/urls' 
import ViewFeed from '@/pages/feed'
import SearchRedirect from './SearchRedirect'
import DoubledSportsRedirect from './DoubledSportsRedirect'

const ViewFeedback = lazy(() => import('@/pages/ViewFeedback'))
const ViewNotFound = lazy(() => import('@/pages/ViewNotFound')) 
const ViewAbout = lazy(() => import('@/pages/about')) 
const ViewHowToBuyBitcoin = lazy(() => import('@/pages/how-to-buy-bitcoin'))
const ViewBrazilElections = lazy(() => import('@/pages/brazil-elections'))

export default [
  { path: '/q/suggest', element: <Navigate to="/i/feedback/suggestion" replace /> },
  { path: ['/i/feedback', '/i/feedback/:type'], element: <ViewFeedback /> },
  { path: howItWorksUrl(), element: <ViewAbout /> }, 
  { path: notFoundUrl(), element: <ViewNotFound /> }, 
  { path: buyBitcoinInfoUrl(), element: <ViewHowToBuyBitcoin />, isModal: true },
  { path: '/', element: <ViewFeed /> },
  { path: '/manifest', element: <ViewFeed /> },
  { path: '/markets/sports/sports/*', element: <DoubledSportsRedirect /> },
  { path: '/markets/*', element: <ViewFeed /> },
  { path: '/tags/*', element: <ViewFeed /> },
  { path: '/markets/tags', element: <ViewFeed /> },
  { path: '/search', element: <SearchRedirect /> },
  { path: brazilElectionsUrl(), element: <ViewBrazilElections /> },
]
